import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import AuthService from 'core/utils/auth/auth-service';
import { startFileDownload } from 'components/ui/FileDownload/reducer';
import QaReportForm from './QaReportForm';

const propTypes = {
  onCancel: PropTypes.func.isRequired,
  testType: PropTypes.string.isRequired,
};

class QaReportFormContainer extends Component {
  handleSubmit = (values, setSubmitting) => {
    const { startFileDownload, testType } = this.props;
    const token = AuthService.getToken();

    setSubmitting(false);
    startFileDownload({
      actionPath: `${process.env.REACT_APP_PUBLIC_API_URL}/quality_assurance_reports`,
      method: 'POST',
      queryParams: Object.assign({ token, test_type: testType }, values),
    });
  }

  handleCancel = () => {
    this.props.onCancel();
  }

  render() {
    return (
      <div>
        <QaReportForm
          onSubmit={this.handleSubmit}
          onCancel={this.handleCancel}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    startFileDownload,
  }, dispatch);
};

QaReportFormContainer.propTypes = propTypes;

export default connect(undefined, mapDispatchToProps)(QaReportFormContainer);



// WEBPACK FOOTER //
// ./src/features/qa/QaReportModal/QaReportFormContainer.js